// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.audio-trimmer_absolute_ADSPM {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    /* Force the browser to paint separately to avoid composite cost with waveform */
    transform: translateZ(0);
}

.audio-trimmer_selector_iKR5p {
    cursor: pointer;
}

.audio-trimmer_trim-background_KsrTj {
    cursor: pointer;
    touch-action: none;
}

.audio-trimmer_trim-background-mask_8N24O {
    border: 1px solid var(--red-tertiary);
    opacity: 0.5;

    background: repeating-linear-gradient(
        45deg,
        var(--red-primary),
        var(--red-primary) 10px,
        var(--red-tertiary) 10px,
        var(--red-tertiary) calc(2 * 10px)
    );
}

.audio-trimmer_selection-background_hVvWC {
    background: var(--looks-secondary);
    opacity: 0.5;
}

.audio-trimmer_start-trim-background_DuZTO .audio-trimmer_trim-background-mask_8N24O {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.audio-trimmer_end-trim-background_NiFqX .audio-trimmer_trim-background-mask_8N24O {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.audio-trimmer_trim-line_aO1CR {
    position: absolute;
    top: 0;
    width: 0px;
    height: 100%;
    border: 1px solid var(--red-tertiary);
}

.audio-trimmer_selector_iKR5p .audio-trimmer_trim-line_aO1CR {
    border: 1px solid var(--looks-secondary);
}

.audio-trimmer_playhead-container_swgsl {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
}

.audio-trimmer_playhead_qRYeq {
    /*
        Even though playhead is just a line, it is 100% width (the width of the waveform)
        so that we can use transform: translateX() using percentages.
    */
    width: 100%;
    height: 100%;
    border-left: 1px solid var(--looks-secondary);
    border-top: none;
    border-bottom: none;
    border-right: none;
}

.audio-trimmer_right-handle_YhId4 {
    transform: scaleX(-1);
}

.audio-trimmer_selector_iKR5p .audio-trimmer_left-handle_z3PmZ {
    left: -1px
}

.audio-trimmer_selector_iKR5p .audio-trimmer_right-handle_YhId4 {
    right: -1px
}

.audio-trimmer_trimmer_Y4lVW .audio-trimmer_left-handle_z3PmZ {
    right: -1px
}

.audio-trimmer_trimmer_Y4lVW .audio-trimmer_right-handle_YhId4 {
    left: -1px
}

.audio-trimmer_trim-handle_vVOON {
    position: absolute;
    width: 30px;
    height: 30px;
    right: 0;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.audio-trimmer_trimmer_Y4lVW .audio-trimmer_trim-handle_vVOON {
    filter: hue-rotate(-240deg) brightness(1.35);
}

.audio-trimmer_trim-handle_vVOON img {
    position: absolute;
    width: 30px;
    height: 30px;
    left: calc(3px * 1.5);

    /* Make sure image dragging isn't triggered */
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    user-drag: none;
    -webkit-user-drag: none; /* Autoprefixer doesn't seem to work for this */

    transition: 0.2s;
}

.audio-trimmer_top-trim-handle_P76zB {
    top: calc(-30px + 3px);
}

.audio-trimmer_bottom-trim-handle_AptpN {
    bottom: calc(-30px + 3px);
}

.audio-trimmer_top-trim-handle_P76zB img {
    transform: scaleY(-1);
}
`, "",{"version":3,"sources":["webpack://./src/components/audio-trimmer/audio-trimmer.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;;IAEZ,gFAAgF;IAChF,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,YAAY;;IAEZ;;;;;;KAMC;AACL;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;;;KAGC;IACD,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;;IAErB,6CAA6C;IAC7C,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;IACf,uBAAuB,EAAE,+CAA+C;;IAExE,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.absolute {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n\n    /* Force the browser to paint separately to avoid composite cost with waveform */\n    transform: translateZ(0);\n}\n\n.selector {\n    cursor: pointer;\n}\n\n.trim-background {\n    cursor: pointer;\n    touch-action: none;\n}\n\n.trim-background-mask {\n    border: 1px solid var(--red-tertiary);\n    opacity: 0.5;\n\n    background: repeating-linear-gradient(\n        45deg,\n        var(--red-primary),\n        var(--red-primary) 10px,\n        var(--red-tertiary) 10px,\n        var(--red-tertiary) calc(2 * 10px)\n    );\n}\n\n.selection-background {\n    background: var(--looks-secondary);\n    opacity: 0.5;\n}\n\n.start-trim-background .trim-background-mask {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.end-trim-background .trim-background-mask {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n\n.trim-line {\n    position: absolute;\n    top: 0;\n    width: 0px;\n    height: 100%;\n    border: 1px solid var(--red-tertiary);\n}\n\n.selector .trim-line {\n    border: 1px solid var(--looks-secondary);\n}\n\n.playhead-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n}\n\n.playhead {\n    /*\n        Even though playhead is just a line, it is 100% width (the width of the waveform)\n        so that we can use transform: translateX() using percentages.\n    */\n    width: 100%;\n    height: 100%;\n    border-left: 1px solid var(--looks-secondary);\n    border-top: none;\n    border-bottom: none;\n    border-right: none;\n}\n\n.right-handle {\n    transform: scaleX(-1);\n}\n\n.selector .left-handle {\n    left: -1px\n}\n\n.selector .right-handle {\n    right: -1px\n}\n\n.trimmer .left-handle {\n    right: -1px\n}\n\n.trimmer .right-handle {\n    left: -1px\n}\n\n.trim-handle {\n    position: absolute;\n    width: 30px;\n    height: 30px;\n    right: 0;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.trimmer .trim-handle {\n    filter: hue-rotate(-240deg) brightness(1.35);\n}\n\n.trim-handle img {\n    position: absolute;\n    width: 30px;\n    height: 30px;\n    left: calc(3px * 1.5);\n\n    /* Make sure image dragging isn't triggered */\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    user-drag: none;\n    -webkit-user-drag: none; /* Autoprefixer doesn't seem to work for this */\n\n    transition: 0.2s;\n}\n\n.top-trim-handle {\n    top: calc(-30px + 3px);\n}\n\n.bottom-trim-handle {\n    bottom: calc(-30px + 3px);\n}\n\n.top-trim-handle img {\n    transform: scaleY(-1);\n}\n"],"sourceRoot":""}]);
// Exports
export var absolute = `audio-trimmer_absolute_ADSPM`;
export var selector = `audio-trimmer_selector_iKR5p`;
var _1 = `audio-trimmer_trim-background_KsrTj`;
export { _1 as "trim-background" };
export var trimBackground = `audio-trimmer_trim-background_KsrTj`;
var _2 = `audio-trimmer_trim-background-mask_8N24O`;
export { _2 as "trim-background-mask" };
export var trimBackgroundMask = `audio-trimmer_trim-background-mask_8N24O`;
var _3 = `audio-trimmer_selection-background_hVvWC`;
export { _3 as "selection-background" };
export var selectionBackground = `audio-trimmer_selection-background_hVvWC`;
var _4 = `audio-trimmer_start-trim-background_DuZTO`;
export { _4 as "start-trim-background" };
export var startTrimBackground = `audio-trimmer_start-trim-background_DuZTO`;
var _5 = `audio-trimmer_end-trim-background_NiFqX`;
export { _5 as "end-trim-background" };
export var endTrimBackground = `audio-trimmer_end-trim-background_NiFqX`;
var _6 = `audio-trimmer_trim-line_aO1CR`;
export { _6 as "trim-line" };
export var trimLine = `audio-trimmer_trim-line_aO1CR`;
var _7 = `audio-trimmer_playhead-container_swgsl`;
export { _7 as "playhead-container" };
export var playheadContainer = `audio-trimmer_playhead-container_swgsl`;
export var playhead = `audio-trimmer_playhead_qRYeq`;
var _8 = `audio-trimmer_right-handle_YhId4`;
export { _8 as "right-handle" };
export var rightHandle = `audio-trimmer_right-handle_YhId4`;
var _9 = `audio-trimmer_left-handle_z3PmZ`;
export { _9 as "left-handle" };
export var leftHandle = `audio-trimmer_left-handle_z3PmZ`;
export var trimmer = `audio-trimmer_trimmer_Y4lVW`;
var _a = `audio-trimmer_trim-handle_vVOON`;
export { _a as "trim-handle" };
export var trimHandle = `audio-trimmer_trim-handle_vVOON`;
var _b = `audio-trimmer_top-trim-handle_P76zB`;
export { _b as "top-trim-handle" };
export var topTrimHandle = `audio-trimmer_top-trim-handle_P76zB`;
var _c = `audio-trimmer_bottom-trim-handle_AptpN`;
export { _c as "bottom-trim-handle" };
export var bottomTrimHandle = `audio-trimmer_bottom-trim-handle_AptpN`;
export default ___CSS_LOADER_EXPORT___;
